<template>
  <nav
    class="navbar fixed-top navbar-dark bg-dark navbar-expand">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a
          class="nav-link"
          href="#"> <h5> ESTIMÉ BUDGÉTAIRE </h5> </a>
      </li>

    </ul>
  </nav>
</template>

<script>
export default {
};
</script>
<style lang="scss" scoped>
@import "src/styles/_includes.scss";
</style>

